
export enum ESharedFileType {
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  UNKNOWN = 'UNKNOWN'
}
